// TODO: Replace with real API responses
import type { InsightsSegment } from "@/types/insightsApi";

// ── Call Records ──────────────────────────────────────────────────────────────

export interface CallRecord {
  conversation: string;
  segment: string;
  direction: "Inbound" | "Outbound";
  customerPhone: string;
  date: string;
  department: string;
  time: string;
  agent: string;
  queue: string;
  totalWaitingTime: string;
  totalTalkTime: string;
}

export const MOCK_CALL_RECORDS: CallRecord[] = [
  {
    conversation: "71a49501-b020-5476-96e7-fec9c497285f",
    segment: "WT4052326269e821f063f98eb82a349b1e",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-03-19",
    department: "",
    time: "00:29",
    agent: "alice.johnson",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "21.00",
  },
  {
    conversation: "58085e5f-3f8a-5e9f-8ebf-e6ccd17d8006",
    segment: "WTb5af7e0babb61188db40218cffbe7606",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-03-19",
    department: "",
    time: "00:30",
    agent: "alice.johnson",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "10.00",
  },
  {
    conversation: "c803120d-4ef6-5395-8f17-ddff344d0461",
    segment: "WT703eec1ad5f92bc4fa820b85875a9c83",
    direction: "Inbound",
    customerPhone: "+440000000002",
    date: "2021-03-19",
    department: "",
    time: "10:12",
    agent: "david.brown",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "31.00",
  },
  {
    conversation: "f8eb1d2c-9269-5bb1-881d-c5f9dcbe5803",
    segment: "WT5af831c7b4ae475486d88c7af3ed461f",
    direction: "Inbound",
    customerPhone: "+440000000002",
    date: "2021-03-19",
    department: "",
    time: "10:30",
    agent: "david.brown",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "30.00",
  },
  {
    conversation: "46c7ebd0-b5a3-5062-b651-14e54b3381a2",
    segment: "WT83ed59961526ee06459426027ce48529",
    direction: "Inbound",
    customerPhone: "+440000000002",
    date: "2021-03-19",
    department: "",
    time: "14:28",
    agent: "david.brown",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "39.00",
  },
  {
    conversation: "b4d79740-fc63-5f4e-96c9-1bf59676ece1",
    segment: "WT40df33213380a879e4cfc4fe8a788ca0",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-03-26",
    department: "",
    time: "11:56",
    agent: "emily.davis",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "29.00",
  },
  {
    conversation: "58faf532-df2f-568a-800d-0172205a9eb4",
    segment: "WTf0fa5e5c21d71021de90bcb64666be17",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-13",
    department: "",
    time: "12:53",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "67.00",
  },
  {
    conversation: "b78420db-378c-5cf3-ae60-edc8cb2c8c8b",
    segment: "WTad143f23259e6b0dd02d8d1741dc4713",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-04-06",
    department: "",
    time: "13:58",
    agent: "henry.moore",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "3.00",
  },
  {
    conversation: "a496cd64-73ac-581f-b958-cba806613878",
    segment: "WT1193d249c4a09467674f925ecc548dd8",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-14",
    department: "",
    time: "13:44",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "7.00",
  },
  {
    conversation: "b50a19f3-0350-599c-bc5e-3fb8fa060f20",
    segment: "WT6898be6825240431fbd75f97ae376c50",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-14",
    department: "",
    time: "13:44",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "31.00",
  },
  {
    conversation: "9e7bb13c-3f8c-5dce-bde7-6c4aff7000a2",
    segment: "WTbeb46a78ba0764129f7c172c253e664d",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-04-08",
    department: "",
    time: "16:12",
    agent: "bob.smith",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "21.00",
  },
  {
    conversation: "afc47039-9c62-5fea-810d-e7d474f241d8",
    segment: "WT0672a85773f098d0bfde8538ca664a9a",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-14",
    department: "",
    time: "14:06",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "92.00",
  },
  {
    conversation: "809a3d78-b8e9-5d82-9eeb-4948a3e03884",
    segment: "WT2b35e4c74e4c7bc34455a4be79e42d6c",
    direction: "Inbound",
    customerPhone: "+440000000002",
    date: "2021-03-19",
    department: "",
    time: "10:38",
    agent: "david.brown",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "17.00",
  },
  {
    conversation: "b3d58dfe-6dd8-5420-88da-4911f4502c3d",
    segment: "WT3f701ae8512f309b0099d82487ce2c22",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-14",
    department: "",
    time: "14:20",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "24.00",
  },
  {
    conversation: "30f80ecb-e627-5fb3-b791-b00c04928d15",
    segment: "WT0dd2c2b675e4d8980d12abad0845e9db",
    direction: "Inbound",
    customerPhone: "+440000000001",
    date: "2021-02-22",
    department: "Customer Success",
    time: "09:25",
    agent: "david.brown",
    queue: "Customer Success",
    totalWaitingTime: "7.00",
    totalTalkTime: "19.00",
  },
  {
    conversation: "909552a2-bd1b-5a7b-ba86-7d91fe540e7f",
    segment: "WT5ca4c35eb4a00339aa19f1b955dc68b8",
    direction: "Inbound",
    customerPhone: "+440000000001",
    date: "2021-02-24",
    department: "Customer Success",
    time: "09:54",
    agent: "grace.wilson",
    queue: "Customer Success",
    totalWaitingTime: "14.00",
    totalTalkTime: "60.00",
  },
  {
    conversation: "0a8a87af-7086-5b40-8d3c-ea68ae42918d",
    segment: "WT78d79a21d6fe66b94a8d6a8ce39ccce1",
    direction: "Inbound",
    customerPhone: "+440000000001",
    date: "2021-02-24",
    department: "Customer Success",
    time: "14:08",
    agent: "henry.moore",
    queue: "Customer Success",
    totalWaitingTime: "3.00",
    totalTalkTime: "54.00",
  },
  {
    conversation: "818be86d-c403-5691-a4cb-344387de9363",
    segment: "WTaee6391694ddad3d0042c405d7cf75c1",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-03-04",
    department: "",
    time: "09:43",
    agent: "henry.moore",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "8.00",
  },
  {
    conversation: "5a45c8cb-9e24-5f75-9585-35c47abe6837",
    segment: "WT36aa1c51efa9ed01c9fe8c201bf4f1ca",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-03-01",
    department: "",
    time: "08:53",
    agent: "henry.moore",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "34.00",
  },
  {
    conversation: "4259cc37-4630-5853-80f8-ad31ca7bf0d5",
    segment: "WT19bb4f20dea0895ccae680b82c4e95c4",
    direction: "Inbound",
    customerPhone: "+440000000001",
    date: "2021-03-01",
    department: "Customer Success",
    time: "16:18",
    agent: "henry.moore",
    queue: "Customer Success",
    totalWaitingTime: "3.00",
    totalTalkTime: "29.00",
  },
  {
    conversation: "84519d74-3843-539b-adc4-95bc494e5ca0",
    segment: "WTf2e2ff778a1222af9fc7b9cb2f337b5d",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-14",
    department: "",
    time: "16:16",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "24.00",
  },
  {
    conversation: "d486aff3-2af8-596a-8000-3dec1f34e2c6",
    segment: "WT29ddabaf48df08d0b115d1fd986d86ef",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-04-13",
    department: "",
    time: "12:52",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "48.00",
  },
  {
    conversation: "ad448a9c-a92e-5bca-9147-0fe97fba8266",
    segment: "WTef80280434a487bb2e1d20a2d15b7084",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-06-21",
    department: "",
    time: "15:23",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "411.00",
  },
  {
    conversation: "1dfab208-eb4f-5346-95ff-b8836a92e5bf",
    segment: "WTe549b1ef5be989c31518d988428dfaac",
    direction: "Inbound",
    customerPhone: "+440000000004",
    date: "2021-06-24",
    department: "",
    time: "13:03",
    agent: "david.brown",
    queue: "Everyone",
    totalWaitingTime: "1.00",
    totalTalkTime: "25.00",
  },
  {
    conversation: "41520911-c0b5-59b2-b3d4-431c460a6499",
    segment: "WT9593f687e937df77bacd5ca06095a907",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-06-24",
    department: "",
    time: "16:26",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "66.00",
  },
  {
    conversation: "f9766119-cf94-59df-87bd-c667363d3954",
    segment: "WTe483b0aacf2be4457d0a8411ef6e93f5",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-06-24",
    department: "",
    time: "16:29",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "47.00",
  },
  {
    conversation: "7ba4dd4c-8cbd-5168-8c8e-54d61a14518a",
    segment: "WTf4449645908da2d714532d48d2a570b2",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-06-24",
    department: "",
    time: "16:30",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "31.00",
  },
  {
    conversation: "c8c8f113-d9be-5e47-863f-27b8c9d75e67",
    segment: "WT10e447d7a1758bee1616db0b9fda8e24",
    direction: "Inbound",
    customerPhone: "+440000000003",
    date: "2021-06-24",
    department: "",
    time: "16:31",
    agent: "frank.miller",
    queue: "Everyone",
    totalWaitingTime: "2.00",
    totalTalkTime: "29.00",
  },
  {
    conversation: "4920fadf-6202-5686-817c-857a3a179acc",
    segment: "WT41f8cfc1d1821396906ff83f516eb9d1",
    direction: "Outbound",
    customerPhone: "+440000000001",
    date: "2021-09-15",
    department: "",
    time: "11:36",
    agent: "alice.johnson",
    queue: "Everyone",
    totalWaitingTime: "",
    totalTalkTime: "5.00",
  },
];

// ── Filter Options ─────────────────────────────────────────────────────────────

export interface AgentOption {
  label: string;
  value: string;
}

export interface QueueOption {
  label: string;
  value: string;
}

export interface DepartmentOption {
  label: string;
  value: string;
}

export const MOCK_AGENTS: AgentOption[] = [
  { label: "Alice Johnson", value: "alice.johnson" },
  { label: "Bob Smith", value: "bob.smith" },
  { label: "Carol White", value: "carol.white" },
  { label: "David Brown", value: "david.brown" },
  { label: "Emily Davis", value: "emily.davis" },
  { label: "Frank Miller", value: "frank.miller" },
  { label: "Grace Wilson", value: "grace.wilson" },
  { label: "Henry Moore", value: "henry.moore" },
];

export const MOCK_TASK_QUEUES: QueueOption[] = [
  { label: "Everyone", value: "Everyone" },
  { label: "Customer Success", value: "Customer Success" }
];

export const MOCK_DEPARTMENTS: DepartmentOption[] = [
  { label: "Sales", value: "Sales" },
  { label: "Support", value: "Support" },
  { label: "Billing", value: "Billing" },
  { label: "Technical", value: "Technical" },
  { label: "Retention", value: "Retention" },
];

// ── InsightsSegment shape (maps CallRecord to the real API type) ──────────────

export const MOCK_SEGMENTS: InsightsSegment[] = MOCK_CALL_RECORDS.map((r) => ({
  conversation: r.conversation,
  segment: r.segment,
  direction: r.direction,
  customerPhone: r.customerPhone,
  externalContact: r.customerPhone,
  date: r.date,
  time: r.time,
  agent: r.agent,
  queue: r.queue,
  department: r.department,
  totalWaitingTime: r.totalWaitingTime,
  totalTalkTime: r.totalTalkTime,
}));
